import type { ComponentType } from "react";
import ExpandSpace2024 from "./pages/ExpandSpace2024";
import HowIHelpedMySisterFindMalwareInRobloxStudio from "./pages/HowIHelpedMySisterFindMalwareInRobloxStudio";
import PenangLearningJourneySelection from "./pages/PenangLearningJourneySelection";
import TheTimeITriedToSellATimeMachine from "./pages/TheTimeITriedToSellATimeMachine";

export const blogPages: Record<string, ComponentType> = {
  "1": PenangLearningJourneySelection,
  "2": HowIHelpedMySisterFindMalwareInRobloxStudio,
  "3": TheTimeITriedToSellATimeMachine,
  "4": ExpandSpace2024,
};
